// extracted by mini-css-extract-plugin
export default {"errorContainer":"NotFound_errorContainer__ZkR-U","errorNum":"NotFound_errorNum__LSg3j"};